export default "__VITE_PUBLIC_ASSET__26cd56c8__"